import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['header', 'cta', 'reasonsModalMessage']> =
	defineContent({
		default: {
			header: {
				id: 'growth.recommendation-confluence.product-name.header',
				description: 'Header for Confluence recommendation message in Jira Side Nav',
				defaultMessage: 'Collaborate on pages in real-time',
				role: 'title',
			},
			cta: {
				id: 'growth.recommendation-confluence.cta.label',
				description: 'CTA text for Confluence recommendation message in Jira Side Nav',
				defaultMessage: 'Try Confluence',
			},
			reasonsModalMessage: {
				id: 'growth.recommendation-confluence.reasons-modal.message',
				defaultMessage:
					"We think {confluence} will improve your team's productivity. The recommendation is based on:",
				description:
					'Explanation of why we think the Confluence recommendation will be relevant to the customer.',
				role: 'description',
			},
		},
	});
